import ContentWrapper from '@/components/ContentWrapper';
import Text from '@/components/Text';
import { BaseBlockComponentProps } from '@/types/block';
import { NextArray } from '@grace-studio/graceful-next/types';
import type { PortableTextBlock } from '@portabletext/types/dist';
import classNames from 'classnames';

type RichTextBlockProps = BaseBlockComponentProps<{
  heading: string;
  text: NextArray<PortableTextBlock>;
  layout: 1 | 2;
}>;

const RichTextBlock: RichTextBlockProps = ({ block }) => (
  <ContentWrapper className="grid-base">
    <Text
      className={classNames(
        'col-span-full [&_p]:pr-6',
        block.layout === 1 ? 'lg:col-span-4' : 'lg:col-span-8'
      )}
      layout={block.layout}
      textComponent={{
        ...block,
        options: { addList: false, addText: true },
      }}
    />
  </ContentWrapper>
);

export default RichTextBlock;
